import React from 'react'

import { Flex, PageHeading } from '@affstore-ds/uikit'
import { useWindowScroll } from '@mantine/hooks'

import { HelmetPageTitle } from '../HelmetPageTitle'
import { MainPageHeaderPropertiesType } from './MainPageHeader.types'

import { useMainPageHeaderStyles } from './MainPageHeader.styled'

export const MainPageHeader = ({
  subtitle,
  title,
  backButtonTooltip,
  badge,
  classNames,
  elementSize,
  helmetTitle,
  logoIcon,
  onBackButtonClick,
  withBackButton,
  ...rest
}: MainPageHeaderPropertiesType) => {
  const [, scrollTo] = useWindowScroll()
  const { classes, cx } = useMainPageHeaderStyles()

  const titleWithBadge = (
    <Flex align={{ base: 'flex-start', md: 'center' }} direction={{ base: 'column-reverse', md: 'row' }} gap={{ base: 12, md: 16 }}>
      {title}
      {badge}
    </Flex>
  )

  const handleBackButtonClick = () => {
    if (onBackButtonClick) {
      scrollTo({ y: 0 })
      onBackButtonClick()
    }
  }

  return (
    <>
      {title && <HelmetPageTitle helmetTitle={helmetTitle} pageTitle={title} />}
      <PageHeading
        subtitle={subtitle}
        title={badge ? titleWithBadge : title}
        backButtonTooltip={backButtonTooltip}
        classNames={{ ...classNames, subtitle: cx(classes.subtitle, classNames?.subtitle) }}
        elementSize={elementSize}
        logoIcon={logoIcon}
        onBackButtonClick={handleBackButtonClick}
        withBackButton={withBackButton}
        withLogo={Boolean(logoIcon)}
        {...rest}
      />
    </>
  )
}
